import React from 'react'
import ContentHeaderContainer from './container'
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import theme from 'theme/ThemeContext';

const ContentHeader = ({
  title,
  //   buttonName,
  //   buttonBoolean,
  //   pageName,
  //   linkPath,
  backButton,
  subtitle,
  handleDrawerToggle,

}) => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  // For showing hamburger only on mobile screens
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ContentHeaderContainer
      title={title}
      backButton={backButton}
      handleBack={handleBack}
      subtitle={subtitle}
      isMobile={isMobile}
      handleDrawerToggle={handleDrawerToggle}
    />
  )
}

export default ContentHeader
